import { render, staticRenderFns } from "./UrlDirectDisplay.vue?vue&type=template&id=2645da52&"
import script from "./UrlDirectDisplay.vue?vue&type=script&lang=ts&"
export * from "./UrlDirectDisplay.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports